// Event emission scaffold. The real Sentry/PostHog integration is a
// post-launch job — this class is the abstraction layer the rest of
// the audio stack codes against so we don't have to chase down call
// sites later.

export default class VoiceTelemetry {
  constructor() {
    this._userId = null;
    this._sessionId = null;
  }

  setUserContext({ userId } = {}) {
    this._userId = userId ?? null;
  }

  setSessionContext({ sessionId } = {}) {
    this._sessionId = sessionId ?? null;
  }

  track(eventName, properties = {}) {
    const payload = {
      ...properties,
      userId: this._userId,
      sessionId: this._sessionId,
      ts: Date.now(),
    };
    console.info('[VoiceTelemetry]', eventName, payload);
  }
}
